import { useEffect, useState } from "react";
import { getFileDownloadUrl } from "../../../api/firebase/firestoreService";

interface UseFetchPdfUrlReturn {
  pdfUrl: string;
  isLoading: boolean;
  error: Error | null;
}

export const useFetchPdfUrl = (filePath?: string): UseFetchPdfUrlReturn => {
  const [pdfUrl, setPdfUrl] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchPdfUrl = async () => {
      if (!filePath) return;

      setIsLoading(true);
      setError(null);
      try {
        const downloadUrl = await getFileDownloadUrl(filePath);
        if (downloadUrl) {
          setPdfUrl(downloadUrl);
        }
      } catch (error) {
        console.error("Error fetching PDF URL:", error);
        setError(error as Error);
      } finally {
        setIsLoading(false);
      }
    };

    if (filePath) {
      fetchPdfUrl();
    }
  }, [filePath]);

  return { pdfUrl, isLoading, error };
};
